import { getSingleProductList } from '../../../globals/my-products/utils';
export class ProductCtasUpdater {
  constructor() {
    this.fillFavoritesList = (result) => {
      if (!this.isFavoritesExist)
        return;
      this.mergeAndEmitChange({
        favorites: {
          list: getSingleProductList(result).map((p) => p.productId),
        },
      });
    };
    this.buttons = undefined;
    this.myProductsGetter = undefined;
  }
  onCcGetOptionsSucceeded(event) {
    if (!this.buttons)
      return;
    if (!this.buttons.favorites && !this.buttons.cart)
      return;
    this.mergeAndEmitChange({
      favorites: this.buttons.favorites && {
        isShown: !event.detail.enableChannelSightOnCart,
      },
      cart: this.buttons.cart && {
        isShown: event.detail.enableChannelSightOnCart,
      },
    });
  }
  onPesProductAddedToFavorites(e) {
    if (!this.isFavoritesExist)
      return;
    const favoritesList = this.buttons.favorites.list || [];
    if (!favoritesList.includes(e.detail)) {
      this.mergeAndEmitChange({
        favorites: {
          list: [...favoritesList, e.detail],
        },
      });
    }
  }
  onPesProductRemovedFromFavorites(e) {
    if (!this.isFavoritesExist)
      return;
    const favoritesList = this.buttons.favorites.list;
    if (favoritesList === null || favoritesList === void 0 ? void 0 : favoritesList.length) {
      this.mergeAndEmitChange({
        favorites: {
          list: favoritesList.filter((i) => i !== e.detail),
        },
      });
    }
  }
  componentDidLoad() {
    var _a;
    (_a = this.myProductsGetter) === null || _a === void 0 ? void 0 : _a.call(this).then(this.fillFavoritesList);
  }
  get isFavoritesExist() {
    var _a;
    return Boolean((_a = this.buttons) === null || _a === void 0 ? void 0 : _a.favorites);
  }
  mergeAndEmitChange(partialButtons) {
    const merged = this.mergeWithExistingButtons(partialButtons);
    this.buttonsChange.emit(merged);
  }
  mergeWithExistingButtons(partialButtons) {
    const updatedButtons = Object.keys(partialButtons).reduce((merged, buttonKey) => {
      if (partialButtons[buttonKey]) {
        merged[buttonKey] = Object.assign(Object.assign({}, this.buttons[buttonKey]), partialButtons[buttonKey]);
      }
      return merged;
    }, {});
    return Object.assign(Object.assign({}, this.buttons), updatedButtons);
  }
  static get is() { return "pes-range-product-ctas-updater"; }
  static get properties() {
    return {
      "buttons": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtasButtons",
          "resolved": "TProductKnownCtasButtons & TProductUnknownCtasButtons",
          "references": {
            "TProductCtasButtons": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "myProductsGetter": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "() => Promise<TGetMyProductsResult>",
          "resolved": "() => Promise<TGetMyProductsResult>",
          "references": {
            "Promise": {
              "location": "global"
            },
            "TGetMyProductsResult": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get events() {
    return [{
        "method": "buttonsChange",
        "name": "buttonsChange",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "TProductCtasButtons",
          "resolved": "TProductKnownCtasButtons & TProductUnknownCtasButtons",
          "references": {
            "TProductCtasButtons": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "ccGetOptionsSucceeded",
        "method": "onCcGetOptionsSucceeded",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "pesProductAddedToFavorites",
        "method": "onPesProductAddedToFavorites",
        "target": "document",
        "capture": false,
        "passive": false
      }, {
        "name": "pesProductRemovedFromFavorites",
        "method": "onPesProductRemovedFromFavorites",
        "target": "document",
        "capture": false,
        "passive": false
      }];
  }
}
